import PropTypes from 'prop-types';
import { Autocomplete, IconButton, TextField, Typography } from '@mui/material';
import TextFormField from './IntegrationTextFormField';
import CheckboxFormField from './IntegrationCheckboxFormField';
import Row from './IntegrationFormRow';
import Iconify from '../../../../../reusable-components/iconify/Iconify';

EDIOrderIntegration.propTypes = {
  value: PropTypes.object,
  sites: PropTypes.array,
  setValue: PropTypes.func,
};

export default function EDIOrderIntegration({ value, setValue, sites }) {

  const setIdentitiesValue = (id, index, inputValue) =>
  {
    setValue(value => {    
      const identities = value.identities?.length > 0 ? value.identities : [{}];      
      identities[index][id] = inputValue;
      return { ...value, identities };
    });
  }

  return (
    <>
      <Row>
        <TextFormField
          header={'ISA End Tag'}
          value={value.isaEndTag}
          onChange={(e) => setValue({ ...value, isaEndTag: e.target.value })}
        />
        <TextFormField
          header={'PO106'}
          value={value.pO106}
          onChange={(e) => setValue({ ...value, pO106: e.target.value })}
        />
        <TextFormField
          header={'Delimiter'}
          value={value.delimiter}
          onChange={(e) => setValue({ ...value, delimiter: e.target.value })}
        />
        <TextFormField
          header={'PO105'}
          value={value.pO105}
          onChange={(e) => setValue({ ...value, pO105: e.target.value })}
        />
      </Row>
      <Row>
        <TextFormField
          header={'BEG02'}
          value={value.beG02}
          onChange={(e) => setValue({ ...value, beG02: e.target.value })}
        />
        <TextFormField
          header={'Reroute Item Id To Restricted Vendor'}
          value={value.rerouteItemIdToRestrictedVendor}
          onChange={(e) => setValue({ ...value, rerouteItemIdToRestrictedVendor: e.target.value })}
        />
        <TextFormField
          header={'GSID'}
          value={value.gsid}
          onChange={(e) => setValue({ ...value, gsid: e.target.value })}
        />
        <TextFormField
          header={'vendorISAIdentityTag'}
          value={value.vendorISAIdentityTag}
          onChange={(e) => setValue({ ...value, vendorISAIdentityTag: e.target.value })}
        />
      </Row>
      <Row>
        <TextFormField
          header={'AgoraISAId'}
          value={value.agoraISAId}
          onChange={(e) => setValue({ ...value, agoraISAId: e.target.value })}
        />
        <TextFormField
          header={'Agora ISA Identity Tag'}
          value={value.agoraISAIdentityTag}
          onChange={(e) => setValue({ ...value, agoraISAIdentityTag: e.target.value })}
        />
        <TextFormField
          header={'File Prefix'}
          value={value.filePrefix}
          onChange={(e) => setValue({ ...value, filePrefix: e.target.value })}
        />
        <TextFormField
          header={'Vendor ISA Identity'}
          value={value.vendorISAIdentity}
          onChange={(e) => setValue({ ...value, vendorISAIdentity: e.target.value })}
        />
      </Row>
      <Row>
        <TextFormField
          header={'Manufacturer Place'}
          value={value.manufacturerPlace832}
          onChange={(e) => setValue({ ...value, manufacturerPlace832: e.target.value })}
        />
        <TextFormField
          header={'Manufacturer Number Place'}
          value={value.manufacturerNumberPlace832}
          onChange={(e) => setValue({ ...value, manufacturerNumberPlace832: e.target.value })}
        />
        <TextFormField
          header={'Ignore Sac Code'}
          value={value.ignoreSacCode}
          onChange={(e) => setValue({ ...value, ignoreSacCode: e.target.value })}
        />
      </Row>
      <Typography variant="subtitle1" sx={{ mt: 1 }}>
        Return Identites <IconButton onClick={() => { setValue({ ...value, identities: [...(value.identities || [{}]), {}] }) }}>
          <Iconify icon="mdi:plus-circle-outline" color="primary" width={28} height={28} />
        </IconButton>
      </Typography>          
      {(value.identities?.length > 0 ? value.identities : [{}]).map((identity, index) => <Row key={index}>
        <>
          {index === 0 && <Typography variant="subtitle1" sx={{ mt: 1 }}>Return PS Identity</Typography>}
          <TextField
            fullWidth
            size="small"
            value={identity.psIdentity ?? ""}
            onChange={(e) => setIdentitiesValue("psIdentity", index, e.target.value)}
            sx={{
              mt: 1,
              '& legend': { display: 'none' },
              '& fieldset': { top: 0 },
              '& .MuiFormLabel-root ': { display: 'none' },
            }}
            autoComplete="off"
            />
        </>
        <>
          {index === 0 && <Typography variant="subtitle1" sx={{ mt: 1 }}>Return Vendor Identity</Typography>}
          <TextField
            fullWidth
            size="small"
            value={identity.vendorIdentity ?? ""}
            onChange={(e) => setIdentitiesValue("vendorIdentity", index, e.target.value)}
            sx={{
              mt: 1,
              '& legend': { display: 'none' },
              '& fieldset': { top: 0 },
              '& .MuiFormLabel-root ': { display: 'none' },
            }}
            autoComplete="off"
            />
        </>
        <>
          {index === 0 && <Typography variant="subtitle1" sx={{ mt: 1 }}>Site</Typography>}
          <Autocomplete
            fullWidth
            size="small"
            value={sites.find(site => site.value === identity.siteId) || null}
            isOptionEqualToValue={(option, value) => option?.value === value?.value}
            onChange={(event, newValue) => {
              setIdentitiesValue("siteId", index, newValue?.value ?? 0);
            }}
            renderInput={(params) => <TextField {...params} label="Search or select" autoComplete="off"/>}
            sx={{
              mt: 0.5,
              '& legend': { display: 'none' },
              '& fieldset': { top: 0 },
              '& .MuiFormLabel-root ': { display: 'none' },
            }}
            options={sites}
          />        
        </>
      </Row>)}
      <Row>
        <CheckboxFormField
          label={'PID'}
          checked={value.pid ?? false}
          onChange={(e) => setValue({ ...value, pid: e.target.checked })}
        />
        <CheckboxFormField
          label={'N2'}
          checked={value.n2 ?? false}
          onChange={(e) => setValue({ ...value, n2: e.target.checked })}
        />
        <CheckboxFormField
          label={'Split File'}
          checked={value.splitFile ?? false}
          onChange={(e) => setValue({ ...value, splitFile: e.target.checked })}
        />
        <CheckboxFormField
          label={'PERRE'}
          checked={value.perre ?? false}
          onChange={(e) => setValue({ ...value, perre: e.target.checked })}
        />
      </Row>
      <Row>
        <CheckboxFormField
          label={'REFPD'}
          checked={value.refpd ?? false}
          onChange={(e) => setValue({ ...value, refpd: e.target.checked })}
        />
        <CheckboxFormField
          label={'REFLI'}
          checked={value.refli ?? false}
          onChange={(e) => setValue({ ...value, refli: e.target.checked })}
        />
        <CheckboxFormField
          label={'Item Total'}
          checked={value.itemTotal ?? false}
          onChange={(e) => setValue({ ...value, itemTotal: e.target.checked })}
        />
        <CheckboxFormField
          label={'NTE'}
          checked={value.nte ?? false}
          onChange={(e) => setValue({ ...value, nte: e.target.checked })}
        />
      </Row>
      <Row>
        <CheckboxFormField
          label={'DTM10'}
          checked={value.dtM10 ?? false}
          onChange={(e) => setValue({ ...value, dtM10: e.target.checked })}
        />
        <CheckboxFormField
          label={'MSG'}
          checked={value.msg ?? false}
          onChange={(e) => setValue({ ...value, msg: e.target.checked })}
        />
        <CheckboxFormField
          label={'Only Allow Non Punchout Items'}
          checked={value.onlyAllowNonPunchoutItems ?? false}
          onChange={(e) => setValue({ ...value, onlyAllowNonPunchoutItems: e.target.checked })}
        />
        <CheckboxFormField
          label={'Category Subs'}
          checked={value.categorySubs ?? false}
          onChange={(e) => setValue({ ...value, categorySubs: e.target.checked })}
        />
      </Row>
      <Row>
        <CheckboxFormField
          label={'Use Messages N9'}
          checked={value.useMessagesN9 ?? false}
          onChange={(e) => setValue({ ...value, useMessagesN9: e.target.checked })}
        />
        <CheckboxFormField
          label={'Country Code'}
          checked={value.countryCode ?? false}
          onChange={(e) => setValue({ ...value, countryCode: e.target.checked })}
        />
        <CheckboxFormField
          label={'Ignore Sac Tax'}
          checked={value.ignoreSacTax ?? false}
          onChange={(e) => setValue({ ...value, ignoreSacTax: e.target.checked })}
        />
        <CheckboxFormField
          label={'Supply Change Charge'}
          checked={value.supplyChangeCharge ?? false}
          onChange={(e) => setValue({ ...value, supplyChangeCharge: e.target.checked })}
        />
      </Row>
      <Row>
        <CheckboxFormField
        label={'Send Phone Number'}
        checked={value.sendPhoneNumber ?? false}
        onChange={(e) => setValue({ ...value, sendPhoneNumber: e.target.checked })}
        />
        <CheckboxFormField
          label={'Net Catch Weight (G39)'}
          checked={value.netCatchWeightG39 ?? false}
          onChange={(e) => setValue({ ...value, netCatchWeightG39: e.target.checked })}
        />
        <CheckboxFormField
          label={'Net Catch Weight (PO4)'}
          checked={value.netCatchWeightPO4 ?? false}
          onChange={(e) => setValue({ ...value, netCatchWeightPO4: e.target.checked })}
        />
        <CheckboxFormField
          label={'DTM Required'}
          checked={value.dtmRequired ?? false}
          onChange={(e) => setValue({ ...value, dtmRequired: e.target.checked })}
        />
      </Row>
      <CheckboxFormField
        label={'Only Allow Two Character UOMs'}
        checked={value.onlyAllowTwoCharUOMs ?? false}
        onChange={(e) => setValue({ ...value, onlyAllowTwoCharUOMs: e.target.checked })}
      />
    </>
  );
}
